export const webDesign = {
  is: {
    title: "Nútímaleg og notendavæn vefhönnun",
    description: "Við höfum ástríðu fyrir því að skapa fallegar og áhrifaríkar vefsíður sem skila raunverulegum árangri fyrir þitt fyrirtæki.",
    featuresTitle: "Hönnun sem skilar árangri",
    featuresDescription: "Við leggjum áherslu á að skapa notendavænar og áhrifaríkar veflausnir",
    features: {
      userFriendly: {
        title: "Notendavæn hönnun",
        description: "Við setjum notendaupplifun í fyrsta sæti með skýru og aðgengilegu viðmóti."
      },
      responsive: {
        title: "Aðlögunarhæf hönnun",
        description: "Hönnun sem virkar fullkomlega á öllum tækjum og skjástærðum."
      },
      visual: {
        title: "Sjónræn upplifun",
        description: "Falleg og áhrifarík hönnun sem fangar athygli og eykur traust."
      },
      custom: {
        title: "Sérsniðin útlit",
        description: "Við höfum þitt vörumerki að leiðarljósi í allri hönnun."
      },
      consistent: {
        title: "Samræmd uppbygging",
        description: "Heildstæð hönnun sem tryggir samræmi í allri upplifun."
      },
      modern: {
        title: "Nútímaleg hönnun",
        description: "Við fylgjum nýjustu straumum og stefnum í vefhönnun."
      }
    },
    processTitle: "Hönnunarferli okkar",
    processDescription: "Við fylgjum ítarlegu ferli til að skapa framúrskarandi hönnun sem uppfyllir þínar þarfir",
    process: {
      step1: {
        title: "Rannsókn og greining",
        description: "Við rannsökum markhóp þinn og greinun þarfir notenda og fyrirtækisins."
      },
      step2: {
        title: "Skipulag og uppbygging",
        description: "Við sköpum grindur og flæðirit til að skipuleggja efni og virkni með tilliti til notendaupplifunar."
      },
      step3: {
        title: "Hönnun viðmóts",
        description: "Við sköpum sjónræna hönnun sem endurspeglar þitt vörumerki og laðar að notendur."
      },
      step4: {
        title: "Prófanir og endurgjöf",
        description: "Við prófum hönnunina með raunverulegum notendum og fáum endurgjöf til að bæta hana enn frekar."
      },
      step5: {
        title: "Lokahönnun og innleiðing",
        description: "Við fullkomnum hönnunina og útbúum allar nauðsynlegar skrár fyrir forritun."
      }
    },
    portfolioTitle: "Dæmi um verk",
    portfolioDescription: "Skoðaðu nýleg verkefni sem við höfum útfært fyrir ánægða viðskiptavini",
    portfolio: {
      project1: {
        title: "Fyrirtækisvefsíða",
        description: "Nútímaleg vefsíða fyrir fyrirtæki í fjármálaþjónustu."
      },
      project2: {
        title: "Vefverslun",
        description: "Notendavæn vefverslun með áherslu á sjónræna upplifun."
      },
      project3: {
        title: "Þjónustuvefsíða",
        description: "Upplýsingavefsíða fyrir heilbrigðisþjónustu með skýru flæði."
      },
      project4: {
        title: "App hönnun",
        description: "Nýstárleg app hönnun fyrir snjallsíma með einfaldri notendaupplifun."
      }
    },
    cta: {
      title: "Tilbúin að skapa fallega og árangursríka vefsíðu?",
      description: "Láttu okkur hjálpa þér að hanna vefsíðu sem skapar árangur og laðar að viðskiptavini."
    }
  },
  en: {
    title: "Modern and User-Friendly Web Design",
    description: "We are passionate about creating beautiful and effective websites that deliver real results for your business.",
    featuresTitle: "Design that Delivers Results",
    featuresDescription: "We focus on creating user-friendly and effective web solutions",
    features: {
      userFriendly: {
        title: "User-Friendly Design",
        description: "We put user experience first with a clear and accessible interface."
      },
      responsive: {
        title: "Responsive Design",
        description: "Design that works perfectly on all devices and screen sizes."
      },
      visual: {
        title: "Visual Experience",
        description: "Beautiful and impactful design that captures attention and builds trust."
      },
      custom: {
        title: "Custom Appearance",
        description: "We keep your brand at the forefront of all design decisions."
      },
      consistent: {
        title: "Coherent Structure",
        description: "Comprehensive design that ensures consistency throughout the experience."
      },
      modern: {
        title: "Modern Design",
        description: "We follow the latest trends and directions in web design."
      }
    },
    processTitle: "Our Design Process",
    processDescription: "We follow a detailed process to create outstanding design that meets your needs",
    process: {
      step1: {
        title: "Research and Analysis",
        description: "We research your target audience and analyze the needs of users and the business."
      },
      step2: {
        title: "Information Architecture",
        description: "We create wireframes and flow charts to organize content and functionality with user experience in mind."
      },
      step3: {
        title: "Interface Design",
        description: "We create visual design that reflects your brand and attracts users."
      },
      step4: {
        title: "Testing and Feedback",
        description: "We test the design with real users and gather feedback to improve it further."
      },
      step5: {
        title: "Final Design and Implementation",
        description: "We perfect the design and prepare all necessary files for programming."
      }
    },
    portfolioTitle: "Portfolio Examples",
    portfolioDescription: "Explore recent projects we've implemented for satisfied clients",
    portfolio: {
      project1: {
        title: "Corporate Website",
        description: "Modern website for a financial services company."
      },
      project2: {
        title: "E-commerce Site",
        description: "User-friendly online store with emphasis on visual experience."
      },
      project3: {
        title: "Service Website",
        description: "Informational website for healthcare services with clear flow."
      },
      project4: {
        title: "App Design",
        description: "Innovative app design for smartphones with simple user experience."
      }
    },
    cta: {
      title: "Ready to create a beautiful and effective website?",
      description: "Let us help you design a website that creates results and attracts customers."
    }
  },
  es: {
    title: "Diseño Web Moderno y Fácil de Usar",
    description: "Nos apasiona crear sitios web hermosos y efectivos que ofrezcan resultados reales para su negocio.",
    featuresTitle: "Diseño que Ofrece Resultados",
    featuresDescription: "Nos centramos en crear soluciones web fáciles de usar y efectivas",
    features: {
      userFriendly: {
        title: "Diseño Fácil de Usar",
        description: "Ponemos la experiencia del usuario en primer lugar con una interfaz clara y accesible."
      },
      responsive: {
        title: "Diseño Adaptable",
        description: "Diseño que funciona perfectamente en todos los dispositivos y tamaños de pantalla."
      },
      visual: {
        title: "Experiencia Visual",
        description: "Diseño hermoso e impactante que capta la atención y genera confianza."
      },
      custom: {
        title: "Apariencia Personalizada",
        description: "Mantenemos su marca en primer plano en todas las decisiones de diseño."
      },
      consistent: {
        title: "Estructura Coherente",
        description: "Diseño integral que garantiza la coherencia en toda la experiencia."
      },
      modern: {
        title: "Diseño Moderno",
        description: "Seguimos las últimas tendencias y direcciones en diseño web."
      }
    },
    processTitle: "Nuestro Proceso de Diseño",
    processDescription: "Seguimos un proceso detallado para crear un diseño excepcional que satisfaga sus necesidades",
    process: {
      step1: {
        title: "Investigación y Análisis",
        description: "Investigamos su público objetivo y analizamos las necesidades de los usuarios y del negocio."
      },
      step2: {
        title: "Arquitectura de Información",
        description: "Creamos wireframes y diagramas de flujo para organizar el contenido y la funcionalidad teniendo en cuenta la experiencia del usuario."
      },
      step3: {
        title: "Diseño de Interfaz",
        description: "Creamos un diseño visual que refleja su marca y atrae a los usuarios."
      },
      step4: {
        title: "Pruebas y Retroalimentación",
        description: "Probamos el diseño con usuarios reales y recopilamos comentarios para mejorarlo aún más."
      },
      step5: {
        title: "Diseño Final e Implementación",
        description: "Perfeccionamos el diseño y preparamos todos los archivos necesarios para la programación."
      }
    },
    portfolioTitle: "Ejemplos de Portafolio",
    portfolioDescription: "Explore proyectos recientes que hemos implementado para clientes satisfechos",
    portfolio: {
      project1: {
        title: "Sitio Web Corporativo",
        description: "Sitio web moderno para una empresa de servicios financieros."
      },
      project2: {
        title: "Tienda Online",
        description: "Tienda online fácil de usar con énfasis en la experiencia visual."
      },
      project3: {
        title: "Sitio Web de Servicios",
        description: "Sitio web informativo para servicios de salud con un flujo claro."
      },
      project4: {
        title: "Diseño de Aplicación",
        description: "Diseño innovador de aplicaciones para smartphones con una experiencia de usuario sencilla."
      }
    },
    cta: {
      title: "¿Listo para crear un sitio web hermoso y efectivo?",
      description: "Permítanos ayudarle a diseñar un sitio web que genere resultados y atraiga a los clientes."
    }
  },
  da: {
    title: "Moderne og Brugervenligt Webdesign",
    description: "Vi er passionerede omkring at skabe smukke og effektive websites, der leverer reelle resultater for din virksomhed.",
    featuresTitle: "Design der Leverer Resultater",
    featuresDescription: "Vi fokuserer på at skabe brugervenlige og effektive webløsninger",
    features: {
      userFriendly: {
        title: "Brugervenligt Design",
        description: "Vi sætter brugeroplevelsen først med en klar og tilgængelig brugerflade."
      },
      responsive: {
        title: "Responsivt Design",
        description: "Design der fungerer perfekt på alle enheder og skærmstørrelser."
      },
      visual: {
        title: "Visuel Oplevelse",
        description: "Smukt og virkningsfuldt design, der fanger opmærksomhed og opbygger tillid."
      },
      custom: {
        title: "Tilpasset Udseende",
        description: "Vi holder dit brand i forgrunden af alle designbeslutninger."
      },
      consistent: {
        title: "Sammenhængende Struktur",
        description: "Omfattende design, der sikrer konsistens gennem hele oplevelsen."
      },
      modern: {
        title: "Moderne Design",
        description: "Vi følger de seneste trends og retninger inden for webdesign."
      }
    },
    processTitle: "Vores Designproces",
    processDescription: "Vi følger en detaljeret proces for at skabe fremragende design, der opfylder dine behov",
    process: {
      step1: {
        title: "Undersøgelse og Analyse",
        description: "Vi undersøger din målgruppe og analyserer brugernes og virksomhedens behov."
      },
      step2: {
        title: "Informationsarkitektur",
        description: "Vi opretter wireframes og flowdiagrammer for at organisere indhold og funktionalitet med brugeroplevelsen i tankerne."
      },
      step3: {
        title: "Interfacedesign",
        description: "Vi skaber visuelt design, der afspejler dit brand og tiltrækker brugere."
      },
      step4: {
        title: "Test og Feedback",
        description: "Vi tester designet med rigtige brugere og indsamler feedback for at forbedre det yderligere."
      },
      step5: {
        title: "Endeligt Design og Implementering",
        description: "Vi perfektionerer designet og forbereder alle nødvendige filer til programmering."
      }
    },
    portfolioTitle: "Porteføljeeksempler",
    portfolioDescription: "Udforsk de seneste projekter, vi har implementeret for tilfredse kunder",
    portfolio: {
      project1: {
        title: "Virksomhedswebsite",
        description: "Moderne website til en finansiel servicevirksomhed."
      },
      project2: {
        title: "E-handelsside",
        description: "Brugervenlig webshop med vægt på visuel oplevelse."
      },
      project3: {
        title: "Servicewebsite",
        description: "Informativt website til sundhedsydelser med et klart flow."
      },
      project4: {
        title: "App-design",
        description: "Innovativt app-design til smartphones med enkel brugeroplevelse."
      }
    },
    cta: {
      title: "Klar til at skabe et smukt og effektivt website?",
      description: "Lad os hjælpe dig med at designe et website, der skaber resultater og tiltrækker kunder."
    }
  }
};